import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { UserInfoUpdateRequest } from "@features/admin/users/api";
import { Control, useFieldArray } from "react-hook-form";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  control: Control<UserInfoUpdateRequest, unknown>;
  isTrader: boolean;
};

export const ComissionModal = ({
  isOpen,
  onClose,
  control,
  // isTrader,
}: Props) => {
  const {
    fields: sbpFields,
    append: appendSbp,
    remove: removeSbp,
  } = useFieldArray({
    control,
    name: "commission_config.commission_sbp",
  });

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "commission_config.commission_card",
  });
  const {
    fields: accountFields,
    append: appendAccount,
    remove: removeAccount,
  } = useFieldArray({
    control,
    name: "commission_config.commission_account_number",
  });
  const {
    fields: ibtFields,
    append: appendIBT,
    remove: removeIBT,
  } = useFieldArray({
    control,
    name: "commission_config.commission_ibt",
  });
  const addSbpTier = () => {
    const lastMax =
      sbpFields.length > 0 ? sbpFields[sbpFields.length - 1].max_amount : 0;
    appendSbp({ min_amount: lastMax, max_amount: 0, rate: 0 });
  };

  const addCardTier = () => {
    const lastMax =
      cardFields.length > 0 ? cardFields[cardFields.length - 1].max_amount : 0;
    appendCard({ min_amount: lastMax, max_amount: 0, rate: 0 });
  };

  const addAccountTier = () => {
    const lastMax =
      accountFields.length > 0
        ? accountFields[accountFields.length - 1].max_amount
        : 0;
    appendAccount({ min_amount: lastMax, max_amount: 0, rate: 0 });
  };

  const addIBTTier = () => {
    const lastMax =
      ibtFields.length > 0 ? ibtFields[ibtFields.length - 1].max_amount : 0;
    appendIBT({ min_amount: lastMax, max_amount: 0, rate: 0 });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={"Комиссии"}>
      {/* <form onSubmit={handleSubmit(handleFormSubmit)}> */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">SBP Commissions</h2>
        <div className="flex overflow-x-auto space-x-4 pb-4 max-w-md">
          {sbpFields.map((field, index) => (
            <div
              key={field.id}
              className="flex-shrink-0 w-50 bg-white p-4 rounded shadow"
            >
              <div className="mb-2">
                <Input
                  label="Min Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_sbp.${index}.min_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Max Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_sbp.${index}.max_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Rate"
                  control={control}
                  type="number"
                  name={`commission_config.commission_sbp.${index}.rate`}
                />
              </div>
              <button
                type="button"
                onClick={() => removeSbp(index)}
                className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addSbpTier}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add Tier
        </button>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">Card Commissions</h2>
        <div className="flex overflow-x-auto space-x-4 pb-4 max-w-md">
          {cardFields.map((field, index) => (
            <div
              key={field.id}
              className="flex-shrink-0 w-50 bg-white p-4 rounded shadow"
            >
              <div className="mb-2">
                <Input
                  label="Min Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_card.${index}.min_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Max Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_card.${index}.max_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Rate"
                  control={control}
                  type="number"
                  name={`commission_config.commission_card.${index}.rate`}
                />
              </div>
              <button
                type="button"
                onClick={() => removeCard(index)}
                className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addCardTier}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add Tier
        </button>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          Account Number Commissions
        </h2>
        <div className="flex overflow-x-auto space-x-4 pb-4 max-w-md">
          {accountFields.map((field, index) => (
            <div
              key={field.id}
              className="flex-shrink-0 w-50 bg-white p-4 rounded shadow"
            >
              <div className="mb-2">
                <Input
                  label="Min Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_account_number.${index}.min_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Max Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_account_number.${index}.max_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Rate"
                  control={control}
                  type="number"
                  name={`commission_config.commission_account_number.${index}.rate`}
                />
              </div>
              <button
                type="button"
                onClick={() => removeAccount(index)}
                className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addAccountTier}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add Tier
        </button>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">IBT Commissions</h2>
        <div className="flex overflow-x-auto space-x-4 pb-4 max-w-md">
          {ibtFields.map((field, index) => (
            <div
              key={field.id}
              className="flex-shrink-0 w-50 bg-white p-4 rounded shadow"
            >
              <div className="mb-2">
                <Input
                  label="Min Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_ibt.${index}.min_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Max Amount"
                  control={control}
                  type="number"
                  name={`commission_config.commission_ibt.${index}.max_amount`}
                />
              </div>
              <div className="mb-2">
                <Input
                  label="Rate"
                  control={control}
                  type="number"
                  name={`commission_config.commission_ibt.${index}.rate`}
                />
              </div>
              <button
                type="button"
                onClick={() => removeIBT(index)}
                className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addIBTTier}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add Tier
        </button>
      </section>

      <div style={{ marginTop: "1rem" }}>
        <Button buttonType="button" onClick={onClose}>
          Update
        </Button>
      </div>
      {/* </form> */}
    </Modal>
  );
};
